// Write your code here
import './index.css'

const MoneyDetails = props => {
  // const {details} =
  const {balance, income, expense} = props
  // console.log(balance)
  // console.log(props)
  return (
    <div className="div_2">
      <div className="div_2_1">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/balance-image.png"
          alt="balance"
        />
        <div>
          <p>Your Balance</p>
          <div className="div_2_1_1">
            <p>Rs{` `}</p>
            <p data-testid="balanceAmount">{balance}</p>
          </div>
        </div>
      </div>
      <div className="div_2_2">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/income-image.png"
          alt="income"
        />
        <div>
          <p>Your INCOME</p>
          <div className="div_2_1_1">
            <p>Rs {` `} </p> <p data-testid="incomeAmount">{income}</p>
          </div>
        </div>
      </div>
      <div className="div_2_3">
        <img
          src="https://assets.ccbp.in/frontend/react-js/money-manager/expenses-image.png "
          alt="expenses
"
        />
        <div>
          <p>Your Expenses</p>
          <div className="div_2_1_1">
            <p>Rs {` `} </p>
            <p data-testid="expensesAmount">{expense}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default MoneyDetails
